import DesignerNavigationInfiniteScroll from './DesignerNavigationInfiniteScroll.container';

export default DesignerNavigationInfiniteScroll;
